import * as React from 'react';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import RunLink from 'components/GroupRun/RunLink.tsx'
import RunMapLink from 'components/GroupRun/RunMapLink.tsx'

export default function RunDetails() {
  return (
    <Container sx={{
      display: 'flex',
      width: '100%',
    }}>
      
      <List sx={{ width: '100%' }}>
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={
              <React.Fragment>
                <Typography variant="body2" component="span">
                    <p>If you are feeling adventurous, join Andrew and friends for an easy wedding day group run. They will be doing a lap along the Charles river (weather permitting).</p>
                    <p>Meet at 10AM by the Kimpton Marlowe Hotel (see link below). Group departs sharply at 10:15AM at an inclusive pace (10 min/mi - 12 min/mi)</p>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider component="li" />
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Location
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography component="span" sx={{fontSize: 16, fontWeight: "bold"}}><RunLink underline='always' /></Typography>
                <Typography variant="body2"><RunMapLink /></Typography>
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </Container>
  );
}
